import configService from './app-config.service';

const getMissmatchData = async (authToken) => {
    const headers = new Headers();
    headers.append('Authorization', `Bearer ${authToken}`);

    const options = {
        method: 'GET',
        headers: headers
    };

    const response = await fetch(`${configService.appConfig.apiUrl}/DataHealth/getMismatch`, options);

    if (!response.ok) {
        const message = `An error occurred: ${response.statusText}`;
        console.error(message);
        return;
    }

    const jsonData = await response.json();
    return jsonData;
};

const getCountByLookup = async (authToken) => {
    const headers = new Headers();
    headers.append('Authorization', `Bearer ${authToken}`);

    const options = {
        method: 'GET',
        headers: headers
    };

    const response = await fetch(`${configService.appConfig.apiUrl}/DataHealth/getCount`, options);

    if (!response.ok) {
        const message = `An error occurred: ${response.statusText}`;
        console.error(message);
        return;
    }

    const jsonData = await response.json();
    return jsonData;
};

export default {
    getMissmatchData,
    getCountByLookup
};
